const serverSide = typeof window === 'undefined'

export const navigateToPage = (path: string) => {
  if (serverSide) return
  window.location.href = path
}

export const reloadPage = () => {
  if (serverSide) return
  window.location.reload()
}
